export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7945.d9a5ad4a.jpg";